var map = {
	"./ranking-1.svg": "8c85",
	"./ranking-2.svg": "e66b",
	"./ranking-3.svg": "e6ae",
	"./ranking-4.svg": "cdcd",
	"./ranking-5.svg": "5a83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8007";